import { CheckOutlined, CloseOutlined } from '@ant-design/icons'
import { message, Switch } from 'antd'
import { useEffect, useState } from 'react'
import { checkConfig, getHomePageInfo } from '../../api/api'
import './index.css'

export default function Homepage() {
  const [Info, setInfo] = useState()
  const [isRent, setIsRent] = useState(1)
  const [isSale, setIsSale] = useState(1)
  // useEffect(async()=>{
  //     const data=await getHomePageInfo()
  //     console.log(data);
  // },[])

  useEffect(() => {
    getHomePageInfo()
      .then((res) => {
        setInfo(res.data.data)
        if (res.data.data.rent_audit_status === 0) {
          //设置审核（0表示不需要审核，1表示需要审核）
          console.log('rent不需要审核')
          setIsRent(0)
        }
        if (res.data.data.sale_audit_status === 0) {
          console.log('sale不需要审核')
          setIsSale(0)
        }
        // console.log(res.data.data);
      })
      .catch((err) => {
        console.log(err)
      })
  }, [])

  const change = (key) => (value) => {
    console.log(value, key)
    if (value) {
      checkConfig(key, 1).then((res) => {
        console.log(res)
        if (key === 1) {
          message.success('转租/找室友审核已打开')
        } else if (key === 2) {
          message.success('闲置二手审核已打开')
        }
      })
    } else {
      checkConfig(key, 0).then((res) => {
        if (key === 1) {
          message.success('转租/找室友审核已关闭')
        } else if (key === 2) {
          message.success('闲置二手审核已关闭')
        }
        console.log(res)
      })
    }
  }

  return (
    <div>
      <div className="sections">
        <div className="box Count">
          <div className="Content">
            <p className="title">总用户数量</p>
            <p>{Info?.users}</p>
          </div>

          <div className="divider"></div>

          <div className="Content">
            <p className="title">总会员数量</p>
            <p>{Info?.memberships}</p>
          </div>
        </div>

        <div className="box Count">
          <div className="Content">
            <p className="title">总帖子数量</p>
            <p>{Info?.threads}</p>
          </div>

          <div className="divider"></div>

          <div className="Content">
            <div
              style={{
                textAlign: 'left',
                marginBottom: '10px',
                fontWeight: '400',
              }}
            >
              <span style={{ marginRight: '100px' }}>本周新增帖子</span>
              <span>{Info?.weekly_threads}</span>
            </div>
            <div style={{ textAlign: 'left', fontWeight: '400' }}>
              <span style={{ marginRight: '100px' }}>今日新增帖子</span>
              <span>{Info?.daily_threads}</span>
            </div>
          </div>
        </div>

        <div className="box Count" style={{ marginRight: '0px' }}>
          <div className="Content">
            <p className="title">待审核帖子数量</p>
            <p>{Info?.unaudited_threads}</p>
          </div>

          <div className="divider"></div>

          <div className="Content">
            <p className="title">待审核评论数量</p>
            <p>{Info?.unaudited_posts}</p>
          </div>
        </div>
        <div></div>
      </div>

      <div className="secondSection">
        <div className="title">
          <p>发帖是否需要审核</p>
        </div>

        <div className="verticalDivider"></div>

        <div>
          <span className="title">转租/找舍友:</span>
          <Switch
            key={isRent} //在初始化时可以刷新初始状态
            checkedChildren="开"
            unCheckedChildren="关"
            defaultChecked={isRent === 1 ? true : false}
            onChange={change(1)}
          />
        </div>
        <div>
          <span className="title">闲置二手:</span>
          <Switch
            key={isSale} //在初始化时可以刷新初始状态
            checkedChildren="开"
            unCheckedChildren="关"
            defaultChecked={isSale === 1 ? true : false}
            onChange={change(2)}
          />
        </div>
      </div>


    </div>
  )
}
